export const GetAddressFromAddressLine = (value: string) => value.split(/[0-9]/)[0].trim();

export const GetHousenumberFromAddressLine = (value: string) => value.replace(GetAddressFromAddressLine(value), "").trim()
